import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from './auth/authContext'

const WebSocketProvider = () => {
  const [data, setData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [verMapa, setVerMapa] = useState(false);
  const [latitud, setLatitud] = useState(0);
  const [longitud, setLongitud] = useState(0);
  const {currentUser} = useContext(AuthContext);
  const [socket, setSocket] = useState(null); // Para guardar la conexión WebSocket

  useEffect(() => {
    // Crear WebSocket una sola vez
    const socket = new WebSocket('wss://win2025.advanpro.com.mx:4000');
    // const socket = new WebSocket('wss://cloudservices.advanpro.com.mx:4000');

    setSocket(socket);

    socket.onopen = () => {
      console.log('Conectado al WebSocket');
    };

    socket.onmessage = (event) => {
      console.log('Mensaje recibido del WebSocket:', event.data);
      const parsed = JSON.parse(event.data);
      
      // Verifica si el mensaje corresponde al usuario
      console.log('Validando compañías.');
      if (currentUser.idCompany === parsed.idCompany) {
        console.log('La compañía si es la misma.');
        console.log(parsed);
        setData(parsed);
        setShowModal(true);
      }
    };

    socket.onclose = () => {
      console.log('WebSocket cerrado');
    };

    socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    // Cerrar WebSocket cuando el componente se desmonte
    return () => {
      socket.close();
      console.log('WebSocket desconectado');
    };
  }, []);  // El array vacío asegura que esto solo se ejecute una vez al montar el componente

  return (
    <>

        {showModal && (
            <div style={modalStyle}>
            <div style={modalContentStyle}>
                {/* <p>{mensaje}</p> */}
                <p>{data.titulo || 'Mensaje'}</p>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tbody>
                    {data.datos.map((item, index) => (
                    <tr key={index}>
                        <td style={cellStyle}><strong>{item.clave}</strong></td>
                        <td style={cellStyle}>{item.valor}</td>
                    </tr>
                    ))}
                </tbody>
                </table>
                <button style={styles.boton} 
                    onClick={() => {
                        setShowModal(false);
                        const x = data.datos.find(d => d.clave === "Latitud")?.valor;
                        const y = data.datos.find(d => d.clave === "Longitud")?.valor;
                        setLatitud(x);
                        setLongitud(y);
                        setVerMapa(true)}
                    }
                    >Mapa</button>

                <button style={styles.boton} 
                    onClick={() => setShowModal(false)}
                    >Cerrar</button>
            </div>
            </div>
        )}

        {verMapa && (
            <>
            <div style={styles.overlay}>
            <div style={styles.mapaContenedor}>
            <iframe
              title="Mapa"
              width="100%"
              height="100%"
              src={`https://maps.google.com/maps?q=${latitud},${longitud}&z=15&output=embed`}   
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy">
              </iframe>
              <button style={styles.cerrar} onClick={() => setVerMapa(false)}>Cerrar</button>
            </div>
            </div>
            </>
            
        )}

    </>
    
  );
};

export default WebSocketProvider;

// Estilos simples para el modal
const modalStyle = {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  };
  
  const modalContentStyle = {
    background: 'white',
    padding: '2rem',
    borderRadius: '10px',
    minWidth: '300px',
    textAlign: 'center',
  };

  const cellStyle = {
    border: '1px solid #ccc',
    padding: '8px',
  };

  const styles = {
    toast: {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: '#fff',
      border: '1px solid #ccc',
      borderRadius: '10px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
      padding: '16px',
      zIndex: 1000,
      maxWidth: '300px',
      fontSize: '14px',
    },
    table: {
      width: '100%',
      marginTop: '10px',
    },
    boton: {
      marginTop: '10px',
      padding: '8px 12px',
      border: 'none',
      backgroundColor: '#007bff',
      color: '#fff',
      borderRadius: '5px',
      cursor: 'pointer',
      marginRight: '10px'
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 2000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    mapaContenedor: {
      width: '80%',
      height: '80%',
      backgroundColor: '#fff',
      position: 'relative',
      borderRadius: '10px',
      overflow: 'hidden',
    },
    cerrar: {
      position: 'absolute',
      top: 10,
      right: 10,
      backgroundColor: 'red',
      color: '#fff',
      padding: '5px 10px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      zIndex: 3000
    }
  };